﻿export interface IClcTargetedPairsSummary {
    id: number;
    ctrAlias: string;
    patAlias: string;
    recipientABO: string;
    cprA4: number;
    pairedDonorABO: string;
    pairMatchPower: number;
    patientOnDialysis: string;
    waitTimeNKR: number;
    clcu: number;
}